<template>
  <div class="login-container">
    <div class="wrapper">
      <div class="inner">
        <div class="front">
          <img src="" class="logo">

          <el-tabs v-model="activeName">
            <el-tab-pane :label="$t('login_account_login')" name="password"></el-tab-pane>
            <el-tab-pane :label="$t('login_dynamicCode_login')" name="phone" v-if="smsCodeLogin"></el-tab-pane>
          </el-tabs>

          <el-form :model="form" :rules="rules" hide-required-asterisk ref="form">
            <template v-if="activeName === 'password'">
              <el-form-item prop="userName">
                <el-input v-model="form.userName" :placeholder="$t('login_input_username')"
                  prefix-icon="el-icon-user"></el-input>
              </el-form-item>
              <el-form-item prop="password">
                <el-input v-model="form.password" type="password" show-password
                  :placeholder="$t('login_input_password')" prefix-icon="el-icon-lock"></el-input>
              </el-form-item>
              <el-form-item>
                <el-checkbox v-model="rememberPassword">{{ $t('login_remember_password') }}</el-checkbox>
              </el-form-item>
            </template>

            <template v-else>
              <el-form-item prop="mobilePhone">
                <el-input v-model="form.mobilePhone" :placeholder="$t('login_input_mobilePhone')"
                  prefix-icon="el-icon-mobile-phone"></el-input>
              </el-form-item>
              <el-form-item prop="verifyCode">
                <el-input prefix-icon="el-icon-chat-dot-square" :placeholder="$t('login_input_verifyCode')"
                  v-model="form.verifyCode">
                  <template slot="append">
                    <el-button type="info" @click="sendVerifyCode" :disabled="isCounting">{{ buttonText }}</el-button>
                  </template>
                </el-input>
              </el-form-item>
              <el-form-item prop="code" title="code">
                <el-input prefix-icon="el-icon-key" :placeholder="$t('login_input_code')" v-model="form.code">
                  <template slot="append">
                    <canvas ref="captchaCanvas" @click="getCode" slot="append" class="code-canvas"></canvas>
                  </template>
                </el-input>
              </el-form-item>
            </template>
          </el-form>

          <el-button type="primary" @click="login">{{ $t('login') }}</el-button>
          <el-link type="primary" @click="$router.push('/home')">{{ $t('login_later') }}</el-link>

          <el-tooltip :content="$t('login_with_wechat')" placement="left" :hide-after="1000"
            popper-class="switch-tooltip" v-if="wechatLogin">
            <div class="switch" @click="switchLogin">
              <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-icon="QrOutlined">
                <path d="M6.5 7.5a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1v-1Z" fill="white">
                </path>
                <path
                  d="M4.5 2.5c-1.1 0-2 .9-2 2v7c0 1.1.9 2 2 2h7c1.1 0 2-.9 2-2v-7c0-1.1-.9-2-2-2h-7Zm0 2h7v7h-7v-7ZM11 16a1 1 0 1 1 2 0 1 1 0 0 1-2 0Zm0 3.5a1 1 0 1 1 2 0v1a1 1 0 1 1-2 0v-1Zm4-7.5a1 1 0 1 1 2 0 1 1 0 0 1-2 0Zm3.5 0a1 1 0 0 1 1-1h1a1 1 0 1 1 0 2h-1a1 1 0 0 1-1-1ZM15 17c0-1.1.9-2 2-2h2.5c1.1 0 2 .9 2 2v2.5c0 1.1-.9 2-2 2H17c-1.1 0-2-.9-2-2V17Zm4.5 0H17v2.5h2.5V17Zm-15-2c-1.1 0-2 .9-2 2v2.5c0 1.1.9 2 2 2H7c1.1 0 2-.9 2-2V17c0-1.1-.9-2-2-2H4.5Zm0 2H7v2.5H4.5V17ZM15 4.5c0-1.1.9-2 2-2h2.5c1.1 0 2 .9 2 2V7c0 1.1-.9 2-2 2H17c-1.1 0-2-.9-2-2V4.5Zm4.5 0H17V7h2.5V4.5Z"
                  fill="white"></path>
              </svg>
            </div>
          </el-tooltip>

        </div>

        <div class="back">
          <img src="../../assets/二维码.jpg" alt="">
          <el-button type="success" size="medium">{{ $t('login_wechat_login') }}</el-button>
          <p>
            <span>{{ $t('login_wechat_scan_login') }}</span>
            <span>{{ $t('login_school_verify') }}</span>
          </p>
          <el-link type="primary" @click="$router.push('/home')">{{ $t('login_later') }}</el-link>

          <el-tooltip :content="$t('login_with_account')" placement="left" :hide-after="1000"
            popper-class="switch-tooltip">
            <div class="switch" @click="switchLogin">
              <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-icon="ComputerOutlined">
                <path
                  d="M1 4c0-1.1.9-2 2-2h18c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2h-8v2h4a1 1 0 1 1 0 2H7a1 1 0 1 1 0-2h4v-2H3c-1.1 0-2-.9-2-2V4Zm20 0H3v12h18V4Z"
                  fill="white"></path>
              </svg>
            </div>
          </el-tooltip>
        </div>
      </div>
    </div>

    <el-radio-group size="small" v-model="language" class="language">
      <el-radio-button label="zh">中文</el-radio-button>
      <el-radio-button label="en">English</el-radio-button>
    </el-radio-group>
  </div>
</template>

<script>
const { jumpURL } = projectConfig
import * as api from './api'
import md5 from '@/utils/md5'
export default {
  name: 'Login',
  data() {
    var validateUserName = (rule, value, callback) => {
      if (!value) {
        callback(new Error(this.$t('login_username_required')))
      } else {
        callback()
      }
    }
    var validatePassword = (rule, value, callback) => {
      if (!value) {
        callback(new Error(this.$t('login_password_required')))
      } else {
        callback()
      }
    }
    var validatePhone = (rule, value, callback) => {
      if (!value) {
        callback(new Error(this.$t('login_mobilePhone_required')))
      } else {
        if (/^1[3-9]\d{9}$/.test(value)) {
          callback()
        } else {
          callback(new Error(this.$t('login_mobilePhone_format')))
        }
      }
    }
    // 图片验证码
    var validateCode = (rule, value, callback) => {
      if (!value) {
        callback(new Error(this.$t('login_code_required')))
      } else if (value.toLowerCase() !== this.captchaText.toLowerCase()) {
        callback(new Error(this.$t('login_code_incorrect')))
      } else {
        callback()
      }
    }
    // 动态验证码
    var validateVerifyCode = (rule, value, callback) => {
      if (!value) {
        callback(new Error(this.$t('login_verifyCode_required')))
      } else {
        callback()
      }
    }
    return {
      language: 'zh',
      jumpURL,
      activeName: 'password',
      smsCodeLogin: false,
      wechatLogin: false,
      rememberPassword: false,
      form: {
        userName: '',
        password: '',
        mobilePhone: '',
        code: '',
        verifyCode: ''
      },
      captchaText: '',
      rules: {
        userName: [{ required: true, validator: validateUserName, trigger: ['change', 'blur'] }],
        password: [{ required: true, validator: validatePassword, trigger: ['change', 'blur'] }],
        mobilePhone: [{ required: true, validator: validatePhone, trigger: ['change', 'blur'] }],
        code: [{ required: true, validator: validateCode, trigger: ['change', 'blur'] }],
        verifyCode: [{ required: true, validator: validateVerifyCode, trigger: ['change', 'blur'] }]
      },
      isCounting: false,
      countdown: 60,
      timer: null
    }
  },
  computed: {
    buttonText() {
      return this.isCounting ? `${this.countdown}秒后重试` : this.$t('login_get_verify_code')
    },
  },
  watch: {
    activeName() {
      this.$nextTick(() => {
        this.getCode()
      })
      this.$refs.form.resetFields()
    },
    language(val) {
      localStorage.setItem('language', val)
      this.$i18n.locale = val
      this.$refs.form.resetFields()
    }
  },
  beforeCreate() {
    // 设备类型
    const isMobile = /Mobile|Android|iPhone/i.test(navigator.userAgent)
    if (isMobile) return window.location.href = `${jumpURL}/mobile/`
  },
  async mounted() {
    const { data: { settingValue: baseUrl } } = await api.getConfigInfo('minio_baseUrl')
    const { data: { settingValue: loginBg } } = await api.getConfigInfo('login_bg')
    const { data: { settingValue: logoSrc } } = await api.getConfigInfo('system_logo')
    document.querySelector('.login-container').style.backgroundImage = `url(${baseUrl}${loginBg})`
    document.querySelector('.logo').src = `${baseUrl}${logoSrc}`
  },
  async created() {
    const language = localStorage.getItem('language')
    if (language) {
      this.language = language
      this.$i18n.locale = language
    }
    const savedUser = localStorage.getItem('savedUser')
    if (savedUser) {
      const { userName, password } = JSON.parse(savedUser)
      this.form.userName = userName
      this.form.password = password
      this.rememberPassword = true
    }
    const { data: { settingValue: smsCodeLogin } } = await api.getConfigInfo('sms_code_login')
    this.smsCodeLogin = Boolean(+smsCodeLogin)
    const { data: { settingValue: wechatLogin } } = await api.getConfigInfo('wechat_login')
    this.wechatLogin = Boolean(+wechatLogin)
  },
  beforeDestroy() {
    if (this.timer) clearInterval(this.timer)
  },
  methods: {
    generateRandomText(length = 4) {
      const chars = 'ABCDEFGHJKLMNPQRSTUVWXYZabcdefghjkmnpqrstuvwxyz0123456789'
      let text = ''
      for (let i = 0; i < length; i++) {
        text += chars.charAt(Math.floor(Math.random() * chars.length))
      }
      this.captchaText = text
      return text
    },
    getCode() {
      const canvas = this.$refs.captchaCanvas
      if (!canvas) {
        console.log('canvas 不存在')
        return
      }
      const ctx = canvas.getContext('2d')
      canvas.width = 120
      canvas.height = 34
      if (!ctx) {
        console.log('无法或者canvas上下文')
        return
      }
      // 绘制背景
      ctx.fillStyle = '#f5f5f5'
      ctx.fillRect(0, 0, canvas.width, canvas.height)
      // 生成随机文本
      const text = this.generateRandomText()
      // 绘制文本
      ctx.font = 'bold 20px Arial'
      ctx.textAlign = 'center'
      ctx.textBaseline = 'middle'
      // 随机颜色和位置
      for (let i = 0; i < text.length; i++) {
        ctx.fillStyle = `rgb(${Math.random() * 100 + 50}, ${Math.random() * 100 + 50}, ${Math.random() * 100 + 50})`
        ctx.translate(15 + i * 25, 20)
        ctx.rotate((Math.random() - 0.5) * 0.3)
        ctx.fillText(text[i], 0, 0)
        ctx.setTransform(1, 0, 0, 1, 0, 0) // 重置变换
      }
      // 绘制干扰线
      for (let i = 0; i < 5; i++) {
        ctx.strokeStyle = `rgb(${Math.random() * 150}, ${Math.random() * 150}, ${Math.random() * 150})`
        ctx.beginPath()
        ctx.moveTo(Math.random() * canvas.width, Math.random() * canvas.height)
        ctx.lineTo(Math.random() * canvas.width, Math.random() * canvas.height)
        ctx.stroke()
      }
      // 绘制干扰点
      for (let i = 0; i < 30; i++) {
        ctx.fillStyle = `rgb(${Math.random() * 200}, ${Math.random() * 200}, ${Math.random() * 200})`
        ctx.beginPath()
        ctx.arc(Math.random() * canvas.width, Math.random() * canvas.height, 1, 0, 2 * Math.PI)
        ctx.fill()
      }
    },
    sendVerifyCode() {
      // 先校验手机号
      if (!/^1[3-9]\d{9}$/.test(this.form.mobilePhone)) {
        this.$refs.form.validateField('mobilePhone')
        return
      }
      // 防止重复点击
      if (this.isCounting) return
      this.isCounting = true
      this.$message.success("验证码已发送")
      // 开始倒计时
      this.startCountdown()
      api.getCode({
        mobilePhone: this.form.mobilePhone,
        verifyCode: md5(this.form.mobilePhone)
      })
    },
    startCountdown() {
      this.isCounting = true
      const timer = setInterval(_ => {
        if (this.countdown > 0) {
          this.countdown--
        } else {
          clearInterval(timer)
          this.isCounting = false
          this.countdown = 60
        }
      }, 1000)
    },
    async login() {
      this.$refs.form.validate(async valid => {
        if (valid) {
          this.form.platformType = this.activeName === 'password' ? 1 : 2
          const { data: { token, expireTime } } = this.activeName === 'password' ? await api.accountLogin(this.form) : await api.phoneLogin(this.form)
          if (this.activeName === 'password' && this.rememberPassword) {
            localStorage.setItem('savedUser', JSON.stringify({
              userName: this.form.userName,
              password: this.form.password
            }))
          }
          else localStorage.removeItem('savedUser')
          const redirect = this.$route.query.redirect_url
          if (redirect) window.location.href = `${decodeURIComponent(redirect)}&token=${token}&expireTime=${expireTime}`
          else {
            localStorage.setItem('sys_token', token)
            localStorage.setItem('expireTime', expireTime)
            this.$router.push('/home')
          }
        }
      })
    },
    switchLogin() {
      const inner = document.querySelector('.inner')
      inner.style.transform = inner.style.transform === 'rotateY(180deg)' ? 'rotateY(0deg)' : 'rotateY(180deg)'
    }
  }
}
</script>

<style lang="scss" scoped>
.login-container {
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;

  .wrapper {
    width: 500px;
    height: 590px;
    perspective: 1000px;

    .inner {
      width: 100%;
      height: 100%;
      position: relative;
      display: flex;
      transform-style: preserve-3d;
      transition: transform 0.6s;

      .front,
      .back {
        position: absolute;
        width: 100%;
        height: 100%;
        -webkit-backface-visibility: hidden;
        backface-visibility: hidden;
        backdrop-filter: blur(10px);
        background: rgba(0, 0, 0, .1);
        border-radius: 20px;
        border: 1px solid rgba(255, 255, 255, .8);
        box-shadow: 0 0 10px rgba(0, 0, 0, .2);
        padding: 80px 100px;
        display: flex;
        flex-direction: column;

        .switch {
          position: absolute;
          top: 0;
          right: 0;
          border-radius: 0 20px 0 0;
          height: 80px;
          aspect-ratio: 1;
          background: $mainColor;
          -webkit-clip-path: polygon(100% 0, 0 0, 100% 100%);
          clip-path: polygon(100% 0, 0 0, 100% 100%);
          cursor: pointer;
          padding: 10px 10px 25px 25px;

          img {
            width: 100%;
            height: 100%;
          }
        }
      }

      .front {
        img {
          height: 60px;
          place-self: center;
          margin-bottom: 30px;
        }

        ::v-deep.el-tabs {

          &__item {
            font-size: 16px;

            &:not(.is-active) {
              color: #fff
            }
          }
        }

        ::v-deep.el-form-item[title='code'] .el-input-group__append {
          padding: 0;
        }

        ::v-deep.el-checkbox__label {
          color: #fff;
        }

        .code-canvas {
          width: 120px;
          height: 34px;
        }

        .el-link {
          margin-top: 20px;
          place-self: center;
        }
      }

      .back {
        align-items: center;
        transform: rotateY(180deg);

        img {
          width: 180px;
          border-radius: 8px;
          margin-bottom: 30px;
        }

        p {
          display: flex;
          flex-direction: column;
          text-align: center;
          gap: 10px;
          color: #fff;
          font-size: 16px;
          margin: 60px 0 30px;
        }
      }
    }
  }

  .language {
    position: absolute;
    top: 50px;
    right: 50px;

    ::v-deep.el-radio-button__inner {
      width: 70px;
    }
  }
}
</style>

<style lang="scss">
.switch-tooltip {
  background: $mainColor !important;
  transform: translateX(10px);

  .popper__arrow {
    border-left-color: $mainColor !important;

    &::after {
      border-left-color: $mainColor !important;
    }
  }
}
</style>
